package uz.ferro.shop.model

import kotlinx.serialization.Serializable

@Serializable
data class GeoAddress(
    val id: Long? = null,
    val addressLine: DictItem? = null,
    val city: City? = null,
    val district: District? = null,
    val street: DictItem? = null,
    val house: String? = null,
    val apartment: String? = null,
    val latitude: Double? = null,
    val longitude: Double? = null,
    val notes: String? = null,
    val createdDate: String? = null
)